import type { Runner } from '@ps/isp-web-services-types';
import classNames from 'clsx';
import React from 'react';

import { useRegulatoryIntl } from '@swf/core/hooks/useRegulatoryIntl';
import { Odds } from '@swf/sports/components/Odds/Odds';

import { TXTWCL_Previous_Odds } from './RunnerDetails.messages.json';
import styles from './RunnerDetails.scss';

interface Props {
  runner: Runner;
  labelClassName: string;
  children: React.ReactElement;
  isPreviousPriceVisible?: boolean;
}

const RunnerDetails: React.FC<Props> = ({
  runner,
  labelClassName,
  children,
  isPreviousPriceVisible
}) => {
  const { formatMessage } = useRegulatoryIntl();
  const hasPreviousPrice = isPreviousPriceVisible && runner.previousWinRunnerOdds.length;

  return (
    <div className={classNames(styles.selection, { [styles.oddsBoost]: hasPreviousPrice })}>
      <span className={labelClassName}>{runner.runnerName}</span>
      {hasPreviousPrice ? (
        <span aria-label={formatMessage(TXTWCL_Previous_Odds)} className={styles.previousPrice}>
          <Odds {...runner.previousWinRunnerOdds[0]} />
        </span>
      ) : null}
      {children}
    </div>
  );
};

export default RunnerDetails;
